const initialState = {
  items: [],
  count: 0,
  item: null,
  isLoading: false
};

export function categoryReducer(state = initialState, action) {
  const { data, category: item, type } = action;
  switch (type) {
    case 'CATEGORY_ERROR':
      return Object.assign({}, state, {
        isLoading: false
      });
    case 'CATEGORY_CREATE':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'CATEGORY_CREATE_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'CATEGORY_GET':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'CATEGORY_GET_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });

    case 'CATEGORIES_GET':
      return Object.assign({}, state, {
        items: [],
        count: 0,
        isLoading: true
      });
    case 'CATEGORIES_GET_OK':
      return Object.assign({}, state, {
        items: data.items,
        count: data.count,
        isLoading: false
      });

    default:
      return state;
  }
}
